const images_base_url = "https://localhost:3000";
const images_base_url1 = "https://www.queenstownservicedapartments.co.nz/";

const bookingLink = "https://www.swiftbook.io/inst/#home?propertyId=883OTk1O2rkk9X4mhKaLIfNNUY4nfEUGXFe40Vc2lpQcVjEZNfwOQ==&JDRN=Y";

export { images_base_url, images_base_url1, bookingLink };